<template>
  <div class="index">
    <div class="index-con">
      <div class="big-title">
        <span>{{ $t("regbigtitle") }}</span>
      </div>

      <!-- Domestic registration -->
      <div class="reg-section">
        <div class="small-title">{{ $t("regDomesticTitle") }}</div>
        <div class="qr-codes">
          <div class="qr-item">
            <div class="text">{{ $t("regScanRegister") }}</div>
            <img src="../../static/qr_register.png" class="qr-img" />
          </div>
          <div class="qr-item">
            <div class="text">{{ $t("regScanPay") }}</div>
            <img src="../../static/qr_pay.png" class="qr-img" />
          </div>
        </div>
        <div class="text">{{ $t("regNoteName") }}</div>
      </div>

      <!-- Overseas registration -->
      <div class="reg-section">
        <div class="small-title">{{ $t("regOverseasTitle") }}</div>
        <div class="text">{{ $t("regPaymentRemittance") }}</div>
        <div class="text pb-10">{{ $t("regCompanyNameCn") }}</div>
        <div class="text pb-10">{{ $t("regCompanyNameEn") }}</div>
        <div class="text pb-10">{{ $t("regBankOpenBank") }}</div>
        <div class="text pb-10">{{ $t("regBankAccountNo") }}</div>
        <div class="text pb-10">{{ $t("regBankSwift") }}</div>
        <div class="text pb-10">{{ $t("regBankNameEn") }}</div>
        <div class="text pb-10">{{ $t("regBankAddress") }}</div>
        <div class="text">{{ $t("regNoteName") }}</div>
      </div>

      <!-- Fee schedule -->
      <div class="reg-section">
        <div class="small-title">{{ $t("regFeeScheduleTitle") }}</div>
        <div class="small-title_2">{{ $t("regFeesTitle") }}</div>
        <div class="text">{{ $t("regConferenceWebsite") }}</div>
        <div class="text">{{ $t("regNoEarlyBird") }}</div>
        <div class="reg-table">
          <el-table stripe :data="$t('regtableData')" border style="width: 100%; margin-bottom: 10px">
            <el-table-column prop="one" :label="$t('regCategory')">
              <template slot-scope="scoped">
                <b class="text-333">{{ scoped.row.one }}</b>
              </template>
            </el-table-column>
            <el-table-column prop="two" :label="$t('regColCNY')">
            </el-table-column>
            <el-table-column prop="three" :label="$t('regColEUR')">
            </el-table-column>
            <el-table-column prop="four" :label="$t('regColUSD')">
            </el-table-column>
          </el-table>
        </div>
        <div class="text">{{ $t("regNoteIncludes") }}</div>
        <div class="text">{{ $t("regNoteOfficial") }}</div>
        <div class="text">
          {{ $t("regNoteDownloadPre") }}<a @click="downloadRegForm"
            style="color: #0a9a7a; text-decoration: underline; cursor: pointer;">{{ $t("regNoteDownloadLink") }}</a>{{
              $t("regNoteDownloadPost") }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  mounted() {
    console.log(window.localStorage.getItem("language"));
  },
  methods: {
    downloadRegForm() {
      const href =
        "https://www.maiqs2026.org/index/public/file/MAIQS2026_Registration_Form2_ACC_FINAL.docx";
      const a = document.createElement("a");
      a.href = href;
      a.download = "MAIQS2026_Registration_Form2_ACC_FINAL.docx";
      a.style.display = "none";
      document.body.appendChild(a);
      a.click();
      a.remove();
    },
  },
};
</script>

<style scoped>
.reg-section {
  margin-top: 40px;
}

.qr-codes {
  display: flex;
  gap: 60px;
  margin-bottom: 20px;
}

.qr-item {
  text-align: center;
}

.qr-img {
  width: 200px;
  height: 200px;
  object-fit: contain;
}

.sb-title {
  color: #0270c0 !important;

}

.mt-50 {
  margin-top: 50px;
}

.d-flex {
  display: flex;
  justify-content: space-between;
}

.w-50 {
  width: calc(50% - 30px);
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 20px;
  box-sizing: border-box;
}

.pb-10 {
  padding-bottom: 10px !important;
  line-height: 1.4 !important;
}

.pb-0 {
  padding-bottom: 0 !important;
}

.btns {
  display: flex;
  margin-bottom: 20px;
}

.btn {
  margin-right: 20px;
  padding: 0 20px;
  background: #0a9a7a;
  height: 40px;
  line-height: 40px;
  display: inline-block;
  color: #fff;
  font-size: 16px;
  border-radius: 4px;
}

.btn-reg {
  cursor: no-drop;
  background: #999;
}

.btn-login {
  background-color: rgb(55, 122, 245);
}

.text-blue {
  color: rgb(55, 122, 245);
}

.mt-30 {
  margin-top: 30px;
}

.email {
  cursor: pointer;
  color: rgb(30, 98, 222);
  font-weight: 600;
}

.index-con {
  margin: 0 auto;
  width: 1200px;
  padding-bottom: 170px;
}

.text {
  box-sizing: border-box;
  color: #333;
  font-size: 16px;
  line-height: 2;
  padding-bottom: 20px;
}

.w-350 {
  width: 350px;
  margin: 0 auto;
  text-indent: 0;
  text-align: center;
}

.small-title {
  font-size: 17px;
  font-weight: 600;
  margin-bottom: 20px;
}

.small-title_2 {
  font-size: 17px;
  font-weight: 600;
}

.text-333 {
  color: #333 !important;
}

@media screen and (max-width: 768px) {
  .index-con {
    width: 100%;
  }

  .nav {
    width: 100%;
  }

  .title {
    font-size: 18px;
  }

  .index {
    padding: 40px 10px 0;
    box-sizing: border-box;
  }

  .d-flex {
    display: block;
  }

  .w-50 {
    width: 100%;
  }

  .qr-codes {
    flex-direction: column;
    gap: 30px;
  }

  .qr-img {
    width: 160px;
    height: 160px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/reg.vue